import { exportExcel } from "@api/stores/financial/exportExcel/api";
import { exportPDF } from "@api/stores/financial/exportPDF/api";
import { stats } from "@api/stores/financial/stats/api";
import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type { IFinancialGetAllParams, IFinancialResponse } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IFinancialResponse>>,
  IPathBaseParam,
  IPaginationParams & IFinancialGetAllParams
>("stores.financial");

export const financial = {
  ...getAllApis,
  stats,
  exportPDF,
  exportExcel,
};
